<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Điểm danh bán trú"
          :link="[
            {
              text: 'Buổi bán trú',
              href: '../boarding-class-session',
            },
          ]"
        />
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <DataFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <DataTable ref="table" />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DataFilter from './Filter.vue'
import DataTable from './Table.vue'

export default {
  components: { Breadcrumbs, DataFilter, DataTable },
  methods: {
    async refresh(query) {
      this.$refs.table.refresh(query)
    },
  },
}
</script>
